export const SUCCESS_GET_ALL_AUGMENT_ADDRESS = 'SUCCESS_GET_ALL_AUGMENT_ADDRESS';
export const FAILED_GET_ALL_AUGMENT_ADDRESS = 'FAILED_GET_ALL_AUGMENT_ADDRESS';
export const SUCCESS_GET_AUGMENT_ADDRESS = 'SUCCESS_GET_AUGMENT_ADDRESS';
export const FAILED_GET_AUGMENT_ADDRESS = 'FAILED_GET_AUGMENT_ADDRESS';
export const SUCCESS_CREATE_AUGMENT_ADDRESS = 'SUCCESS_CREATE_AUGMENT_ADDRESS';
export const FAILED_CREATE_AUGMENT_ADDRESS = 'FAILED_CREATE_AUGMENT_ADDRESS';
export const SUCCESS_UPDATE_AUGMENT_ADDRESS = 'SUCCESS_UPDATE_AUGMENT_ADDRESS';
export const FAILED_UPDATE_AUGMENT_ADDRESS = 'FAILED_UPDATE_AUGMENT_ADDRESS';
export const SUCCESS_DELETE_AUGMENT_ADDRESS = 'SUCCESS_DELETE_AUGMENT_ADDRESS';
export const FAILED_DELETE_AUGMENT_ADDRESS = 'FAILED_DELETE_AUGMENT_ADDRESS';


// WEBPACK FOOTER //
// ./src/state/constants/augmentConstants.js